import { PIN_LOCK_MINUTES, PIN_MAX_FAILURES } from '@doorly/shared';
import { db } from '../../db/schema';

/**
 * Compteur d'échecs PIN **local** — l'équivalent hors ligne de `pin_attempts`
 * côté API. Même règle : `PIN_MAX_FAILURES` essais, puis verrouillage
 * `PIN_LOCK_MINUTES`. Porté par la tablette (Dexie), donc par appareil : un
 * collègue ne peut pas verrouiller quelqu'un depuis une autre tablette.
 *
 * Le verrouillage renvoie vers le mot de passe, il ne bloque jamais la
 * tablette (F8) — c'est la modale qui le dit à l'utilisateur.
 */
export async function localLockRemainingMs(userId: string): Promise<number> {
  const row = await db.pinAttempts.get(userId);
  if (!row?.lockedUntil) return 0;
  return Math.max(0, Date.parse(row.lockedUntil) - Date.now());
}

/** Enregistre un échec ; renvoie le nombre d'essais restants (0 = verrouillé). */
export async function recordLocalFailure(userId: string): Promise<number> {
  const row = await db.pinAttempts.get(userId);
  // Un verrou expiré repart de zéro, comme côté serveur.
  const expired = !!row?.lockedUntil && Date.parse(row.lockedUntil) <= Date.now();
  const failures = (expired ? 0 : (row?.failures ?? 0)) + 1;
  const lockedUntil =
    failures >= PIN_MAX_FAILURES
      ? new Date(Date.now() + PIN_LOCK_MINUTES * 60_000).toISOString()
      : null;
  await db.pinAttempts.put({ userId, failures, lockedUntil });
  return Math.max(0, PIN_MAX_FAILURES - failures);
}

export async function clearLocalFailures(userId: string): Promise<void> {
  await db.pinAttempts.delete(userId);
}
